import React, { useState, useEffect } from "react";
import "./Login.css";
import { getLogingegevensAsync } from "./../services/logingegevens-service";
import HomePage from "./../pages/Home/HomePage";

import { useContext } from "react";
import AuthContext from "./../store/auth-context";

function Login() {
  const authCtx = useContext(AuthContext);
  //console.log("authCtx", authCtx);

  const localStorage = window.localStorage;
  const localEmail = localStorage.getItem("email");
  const localPassword = localStorage.getItem("password");
  //console.log("localEmail", localEmail);
  //console.log("localPassword", localPassword);

  let defaultCheck;
  if (localEmail && localPassword) {
    defaultCheck = true;
  } else {
    defaultCheck = false;
  }
  //console.log("defaultCheck", defaultCheck);

  const [loginGegevens, setLoginGegevens] = useState([]);
  const [email, setEmail] = useState(localEmail || "");
  const [password, setPassword] = useState(localPassword || "");
  const [isOnthouden, setIsOnthouden] = useState(defaultCheck);
  const [error, setError] = useState("");

  useEffect(() => {
    getLogingegevensAsync()
      .then((response) => setLoginGegevens(response.data))
      .catch((err) => console.log(`Fout bij ophalen login gegevens`, err));
  }, []);
  //console.log("loginGegevens", loginGegevens);

  useEffect(() => {
    if (email) {
      localStorage.setItem("email", email);
    }
    if (password) {
      localStorage.setItem("password", password);
    }
  }, [localStorage, email, password]);

  function submitHandler(event) {
    event.preventDefault();

    //console.log("email", email);
    //console.log("wachtwoord", password);
    //console.log("isOnthouden", isOnthouden);

    const resultaat = loginGegevens.filter((loginGegeven) => {
      //console.log(loginGegeven.username);
      //console.log(loginGegeven.password);
      return loginGegeven.username === email && loginGegeven.password === password;
    });
    //console.log("resultaat", resultaat);

    if (resultaat.length === 0) {
      setError("Email en/of wachtwoord zijn NIET correct !!!");
    } else {
      setError("");
      authCtx.login(email, password);

      if (!isOnthouden) {
        localStorage.clear();
        //console.log("localStorage is leeg gemaakt");
      }
    }
  }

  const onCheckboxInputChange = () => {
    setIsOnthouden((isOnthouden) => !isOnthouden);
  };

  return (
    <>
      {authCtx.isLoggedIn ? (
        <HomePage />
      ) : (
        <main className="form-signin w-100 m-auto">
          <form>
            <h1 className="h3 mb-3 fw-normal">Inloggen</h1>

            <div className="form-floating">
              <input
                type="email"
                className="form-control"
                id="floatingInput"
                placeholder="name@example.com"
                autoComplete="username"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
              <label htmlFor="floatingInput">Email</label>
            </div>
            <div className="form-floating">
              <input
                type="password"
                className="form-control"
                id="floatingPassword"
                placeholder="Password"
                autoComplete="current-password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
              <label htmlFor="floatingPassword">Wachtwoord</label>
            </div>

            <div className="checkbox mb-3">
              <label>
                <input
                  type="checkbox"
                  value={isOnthouden}
                  checked={isOnthouden ? "checked" : ""}
                  onChange={onCheckboxInputChange}
                />{" "}
                Herinner mij
              </label>
            </div>
            <p className="foutmelding">{error}</p>
            <button
              className="w-100 btn btn-lg btn-primary"
              type="submit"
              onClick={submitHandler}
            >
              Login
            </button>
          </form>
        </main>
      )}
    </>
  );
}

export default Login;
